// Centralised wrapper around the clipboard API. Callers across the app were
// each running their own `navigator.clipboard.writeText(...).catch(() => {})`
// boilerplate, often with a toast on success. Pass `onSuccess` to fire the
// toast (or any other side-effect) once the write resolves; the helper
// swallows errors silently unless `onError` is provided.

export interface CopyToClipboardOptions {
  onSuccess?: () => void
  onError?: (err: unknown) => void
}

export async function copyToClipboard(text: string, opts: CopyToClipboardOptions = {}): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    opts.onSuccess?.()
    return true
  } catch (err) {
    opts.onError?.(err)
    return false
  }
}
